$( document ).ready(function() {
    $('.c-exp-tabs__item-btn').click(function(){
        $('.c-exp-tabs__item').removeClass('is-active');
        $(this).parents('.c-exp-tabs__item').addClass('is-active');
        setTopDock();
    })

    function setTopDock(){
        var $announcementHeight = $('#shopify-section-announcement-bar').height();
        var $stickyHeaderHeight = $('#sticky-header-wrapper').height();

        setTimeout(function(){
            if($('.shopify-section-header-hidden').length){
                $('.shopify-section--tabs').css('top', $announcementHeight);
            }else{
                $tabs = $announcementHeight + $stickyHeaderHeight + 'px';
                $('.shopify-section--tabs').css('top', $tabs);
            }
        },300)

        $(window).scroll(function(){
            if($('.shopify-section-header-hidden').length){
                $('.shopify-section--tabs').css('top', $announcementHeight);
            }else{
                $tabs = $announcementHeight + $stickyHeaderHeight + 'px';
                $('.shopify-section--tabs').css('top', $tabs);
            }
        })
    }
    setTopDock();

    $(window).resize(function(){
        setTopDock();
    })

});
